export var PbsCookieNames = /*#__PURE__*/function (PbsCookieNames) {
  PbsCookieNames["ECREF_OWNER"] = "ecref_owner";
  PbsCookieNames["ECREF"] = "ecref";
  PbsCookieNames["PBS_CODE"] = "pbs_code";
  PbsCookieNames["PBS_OWNER"] = "pbs_owner";
  PbsCookieNames["PPL_CODE"] = "ppl_code";
  return PbsCookieNames;
}({});